import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'woods-footer',
  templateUrl: './woods-footer.component.html',
  styleUrls: ['./woods-footer.component.scss']
})
export class WoodsFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  gotTop(){
    window.scrollTo(0,0)

  }
}
